import { render } from "./IndexSolutions.vue?vue&type=template&id=7cf1b4df&scoped=true"
import script from "./IndexSolutions.vue?vue&type=script&lang=js"
export * from "./IndexSolutions.vue?vue&type=script&lang=js"

import "./IndexSolutions.vue?vue&type=style&index=0&id=7cf1b4df&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf1b4df"]])

export default __exports__